import { cn } from '@/lib/utils'

/** The Fundus mark: a DIP package with its leads, drawn in the accent colour. */
export function Logo({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={cn('size-6', className)} aria-hidden="true">
      <rect width="32" height="32" className="fill-primary" />
      <g className="stroke-primary-foreground" strokeWidth="2.4" strokeLinecap="round" fill="none">
        <path d="M4 16h4" />
        <path d="M24 16h4" />
      </g>
      <rect x="9" y="11" width="14" height="10" rx="2" className="fill-primary-foreground" />
      <g className="fill-primary">
        <rect x="11.5" y="13" width="1.8" height="6" rx="0.9" />
        <rect x="15.1" y="13" width="1.8" height="6" rx="0.9" />
        <rect x="18.7" y="13" width="1.8" height="6" rx="0.9" />
      </g>
    </svg>
  )
}
